import { makeAutoObservable } from "mobx";

import { UserBudgetReadModel, UserBudgetReadModelFromJSON } from "../../@api";

export class BudgetStore {
  private _budgetInfo: UserBudgetReadModel = UserBudgetReadModelFromJSON({
    hasBudget: false,
    currentUsage: 0,
    budgetLimit: 0,
  } as UserBudgetReadModel);

  private _budgetDisabled: boolean = false;

  private errorStatusCode?: number;

  constructor() {
    makeAutoObservable(this);
  }

  get hasBudget(): boolean {
    return this._budgetInfo.hasBudget && !this._budgetDisabled;
  }

  get remainingBudgetDays(): number | string {
    if (this._budgetInfo.endOfBudgetPeriod) {
      const currentDate = new Date();
      const endDate = new Date(this._budgetInfo.endOfBudgetPeriod);
      const timeDiff = endDate.getTime() - currentDate.getTime();
      return Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1; // +1 to include today
    }
    return "N/A";
  }

  setBudgetInfo(value: UserBudgetReadModel): void {
    this._budgetInfo = value;
  }

  setBudgetDisabled(value: boolean): void {
    this._budgetDisabled = value;
  }

  get budgetDisabled(): boolean {
    return (
      this._budgetDisabled ||
      !this._budgetInfo.hasBudget ||
      (!!this.budgetInfoValue.currentUsage &&
        !!this.budgetInfoValue.budgetLimit &&
        this.budgetInfoValue.currentUsage >= this.budgetInfoValue.budgetLimit)
    );
  }

  get budgetInfoValue(): UserBudgetReadModel {
    return this._budgetInfo;
  }

  get errorCode(): number | undefined {
    return this.errorStatusCode;
  }

  set errorCode(value: number | undefined) {
    if (this.errorStatusCode !== value) {
      this.errorStatusCode = value;
    }
  }
}
